// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"d313db91","796":"84bae997"}[chunkId] + ".chunk.js";
};